var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsights(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#insights_svg__clip0_134_186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 28h28v4H0V0h4v28zm5-2a3 3 0 11.262-5.988l3.225-5.375a3 3 0 115.026 0l3.225 5.375a3.238 3.238 0 01.46-.005l5.324-9.316a3 3 0 112.28 1.302l-5.324 9.316a3 3 0 11-4.991.053l-3.225-5.375a3.238 3.238 0 01-.262.012c-.088 0-.176-.005-.262-.012l-3.225 5.375A3 3 0 019 25.999V26z",
    fill: props.color || 'black'
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "insights_svg__clip0_134_186"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
export default SvgInsights;